import { createFileRoute } from '@tanstack/react-router';

import { ChapterBrowse } from '@/module/Author/Chapter';

export const Route = createFileRoute('/_auth/author/_author/chapter/_chapter/')({
  component: RouteComponent,
});

function RouteComponent() {
  return <ChapterBrowse />;
}
